import { Page, Text, View, Document, Image } from '@react-pdf/renderer'

import JitLogo from './../../assets/jit-logo.png'
import JitLogoBlack from './../../assets/jit-logo-black.png'
import { stylesPdf } from './FabricaPdf.styles'

const ArticulosPDF = ({ data, today, titlePdf }) => {
  const formatNumber = num => {
    const [integerPart, decimalPart] = num.split('.')
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger
  }

  return (
    <Document>
      <Page size="A4" style={stylesPdf.page}>
        <View style={stylesPdf.section}>
          <Image src={JitLogo} style={stylesPdf.imageHeader} />
        </View>
        <View style={stylesPdf.titleContainer}>
          <View style={stylesPdf.titleWraper}>
            <Text style={stylesPdf.title}>Artículos - {titlePdf}</Text>
            <Text style={{ fontSize: 10 }}>{today}</Text>
          </View>
          <Text style={stylesPdf.subtitle}>
            Total artículos: {data?.length}
          </Text>
        </View>
        <Text>
          <Text style={stylesPdf.projectImport}>
            Importe total:{' '}
            {formatNumber(
              data
                .reduce((acc, item) => acc + item.quantity * item.precio, 0)
                .toFixed(2)
            )}{' '}
            €
          </Text>
        </Text>
        {data.map(articulo => (
          <View
            key={articulo.articulo.code}
            style={stylesPdf.cardContainer}
            wrap={false}
          >
            <View style={stylesPdf.cardTitle}>
              <Text style={stylesPdf.titleTextBold}>
                {articulo.articulo.code} - {articulo.articulo.name}
              </Text>
            </View>
            <View style={stylesPdf.container}>
              <Text style={stylesPdf.textData}>
                {`Cantidad: ${formatNumber(articulo.quantity.toFixed(2))} ${articulo.articulo.unit}`}
              </Text>
            </View>
            <View style={stylesPdf.container}>
              <Text style={stylesPdf.textData}>
                Precio unitario: {formatNumber(articulo.precio.toFixed(2))} €
              </Text>
              <Text style={stylesPdf.textData}>
                Precio total:{' '}
                {formatNumber((articulo.quantity * articulo.precio).toFixed(2))}{' '}
                €
              </Text>
            </View>
          </View>
        ))}
        <Text
          style={stylesPdf.pageNumbers}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
        <Image src={JitLogoBlack} style={stylesPdf.imageFooter} fixed />
        <Text style={stylesPdf.footer} fixed>
          Artículos
        </Text>
      </Page>
    </Document>
  )
}

export default ArticulosPDF
